// extracted by mini-css-extract-plugin
export var chevron = "_1v-d";
export var disabled = "_1v-b";
export var error = "_1v-c";
export var hideBorder = "_1v-1";
export var icon = "_1v-e";
export var input = "_1v-0";
export var large = "_1v-f";
export var open = "_1v-9";
export var placeholder = "_1v-a";
export var regular = "_1v-5";
export var singleRowInput = "_1v-2";
export var singleSelectInput = "_1v-3 _1v-0";
export var small = "_1v-4";
export var spinnerContainer = "_1v-i";
export var tag = "_1v-7";
export var tagsContainer = "_1v-8";
export var tagsInput = "_1v-6 _1v-0";
export var xSmall = "_1v-g";
export var xxSmall = "_1v-h";